export const ultraFast = '50ms';
export const faster = '100ms';
export const fast = '150ms';
export const normal = '200ms';
export const slow = '300ms';
export const slower = '400ms';
export const ultraSlow = '500ms';
